










































import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { PanelUserService } from '@/modules/user/services/panel-user.service'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import PinInput from '@/modules/shared/components/panel/PinInput.vue'
import { UpdatePasswordRequestModel } from '@/modules/user/models/user-request.model'

@Component({
  components: { PinInput, AlertNotification, BaseButton, Modal, BaseInput, BaseCard }
})
export default class UserProfileNameForm extends Vue {
  constructor(
    private readonly service: PanelUserService
  ) {
    super()
  }

  $refs!: {
    changePassword: QForm
  }

  @Prop() phone!: string
  @Prop() isVerified!: boolean

  currentPassword = ''
  newPassword = ''
  newPasswordConfirmation = ''

  loading = false

  updatePassword() {
    this.loading = true
    this.$refs.changePassword.validate().then(success => {
      if (success) {
        this.service.updatePassword({
          password: this.currentPassword,
          new_password: this.newPassword,
          new_password_confirmation: this.newPasswordConfirmation
        } as UpdatePasswordRequestModel).onFinish(() => {
          this.reset()
          this.loading = false
        })
      } else this.loading = false
    })
  }

  reset() {
    this.currentPassword = ''
    this.newPassword = ''
    this.newPasswordConfirmation = '-'
    this.$refs.changePassword.resetValidation()
  }

}
